import { writable } from 'svelte/store';
import jwtDecode from 'jwt-decode';

export function setToken (token) {
    localStorage.setItem("token", token);
}

export function clearToken () {
    localStorage.removeItem("token");
}

export function getToken () {
    return localStorage.getItem("token");
}

export function isLoggedIn () {
    const token = localStorage.getItem("token");
    if (token && token.length) {
        // console.log("isLoggedin: ", token, true)
        return true;
    }
    // console.log("isLoggedin: ", token, false)
    return false;
}

export function getTokenAttr(attr) {
    const token = getToken();
    if (token) {
        return jwtDecode(token)[attr];
    }
} 